<div class="tm-modal-body" mat-dialog-content>
  <ng-content #customTemp></ng-content>
  <ng-container *ngIf="!bodyTemp">
    <p>{{ modal.message }}</p>
  </ng-container>
</div>
